import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import {
  getcustomerDeliverypointlist, saveDeliverypointREQ, updateDeliveryPointReq, deleteDeliverypointREQ

} from "../../../../apiservicescall/api";
import { Link } from "react-router-dom";
// import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Switch from "@material-ui/core/Switch";
import { rightToLeft } from '@syncfusion/ej2-base';
import { List } from '@mui/material';

const DeliveryPointMaster = () => {

  const [deliPointPopupModal, setDeliPointPopupModal] = useState(false);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);

  const [deliverypointlist, setDeliverypointlist] = useState([{}]);
  const [largeModal, setLargeModal] = useState(false);
  const [errors, setErrors] = useState({
    delPointName: null,
    delPointCode: null,
    geoLat: null,
    geoLong: null,
    city: null,
    state: null,
    country: null,
    address1: null,
    address2: null,
    pinCode: null,
  });
  const [deletepopup, setDeletepopup] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [deliveryPointDetails, setDeliveryPointDetails] = useState({
    delPointName: "",
    address1: "",
    address2: "",
    country: "",
    delPointCode: 0,
    city: "",
    state: "",
    pinCode: 0,
    geoLat: 0,
    geoLong: 0,
    status: "",
  });

  useEffect(() => {
    getDeliverypointHistory();
  }, []);


  const getDeliverypointHistory = async () => {

    let delPointCode = 0;
    let getDeliverypointlist = await getcustomerDeliverypointlist(delPointCode);
    //  console.log(getDeliverypointlist);
    let getDeliverypoint = getDeliverypointlist && getDeliverypointlist.data.data || [];
    setDeliverypointlist(getDeliverypoint);
    // console.log("getDeliverypoint", getDeliverypoint);
  }


  const saveupdateDeliveryPoint = async () => {

    let data = [{
      delPointName: deliveryPointDetails.delPointName,
      address1: deliveryPointDetails.address1,
      address2: deliveryPointDetails.address2,
      country: deliveryPointDetails.country,
      delPointCode: Number(deliveryPointDetails.delPointCode),
      city: deliveryPointDetails.city,
      state: deliveryPointDetails.state,
      pinCode: deliveryPointDetails.pinCode,
      geoLat: deliveryPointDetails.geoLat,
      geoLong: deliveryPointDetails.geoLong,
      status: "A",
    }]
    // let updatedata=[deliveryPointDetails];
    // console.log("data", data);
    let reqforupload;
    if (!isedit) {
      reqforupload = await saveDeliverypointREQ(data);
    }
    else {
      reqforupload = await updateDeliveryPointReq(data);
    }

    // console.log("saveCustomerDetails", saveCustomerDetails);
    if (reqforupload?.status === 200) {

      setDeliveryPointDetails({});
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      getDeliverypointHistory();
      if (!isedit) {
        swal("Success!", "DeliveryPoint Added", "success");
      } else {
        swal("Success!", "DeliveryPoint Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
    }
  };

  const deleteDeliveryPointlist = async () => {


    let delPointCode = Number(deliveryPointDetails[0]?.delPointCode);
    let status = deliveryPointDetails[0]?.status;
    console.log("delPointCode", delPointCode);
    console.log("status", status);
    let reqfordeliverypoint = await deleteDeliverypointREQ(delPointCode, status);

    console.log("reqfordeliverypoint", reqfordeliverypoint);
    // return false;
    if (reqfordeliverypoint.data.status === true) {
      //setDeliveryPointDetails({});
      setDeletepopup(false);
      setIsview(false);
      setIsedit(false);
      getDeliverypointHistory();
    } else {
      // getoutletMenulist(
      //   selectedrestarant.value,
      //   selectedusers.value
      // );
      setDeletepopup(false);
      swal("Oops", `${reqfordeliverypoint.data.message}`, "error");
    }
  };


  const opnAddDpointModal = (e) => {

    e.preventDefault();
    setDeliveryPointDetails([{}]);
    setLargeModal(!largeModal);
    setIsview(false);
    setIsedit(false);
  };



  const onEditDpoint = (data) => {

    let selectedCustomer = deliverypointlist.find(
      (value, index) => index === data?.rowIndex
    );
   
    setDeliveryPointDetails({
      delPointName: selectedCustomer.delPointName,
      address1: selectedCustomer.address1,
      address2: selectedCustomer.address2,
      delPointCode: selectedCustomer.delPointCode,
      country: selectedCustomer.country,
      city: selectedCustomer.city,
      state: selectedCustomer.state,
      pinCode: selectedCustomer.pinCode,
      geoLat: selectedCustomer.geoLat,
      geoLong: selectedCustomer.geoLong,
      status: selectedCustomer.status,
    })
    setLargeModal(!largeModal);
    setIsedit(!isedit);
    setIsview(false);
    setErrors({});
    setFormIsValid(true);
  }


  const viewDpoint = (data) => {
debugger
console.log('items', data);

let selectedCustomer = deliverypointlist.find(
  (value, index) => index === data?.rowIndex
);
console.log('selectedCustomer', selectedCustomer);
    setDeliveryPointDetails({
      delPointName: selectedCustomer.delPointName,
      address1: selectedCustomer.address1,
      address2: selectedCustomer.address2,
      delPointCode: selectedCustomer.delPointCode,
      country: selectedCustomer.country,
      city: selectedCustomer.city,
      state: selectedCustomer.state,
      pinCode: selectedCustomer.pinCode,
      geoLat: selectedCustomer.geoLat,
      geoLong: selectedCustomer.geoLong,
      status: selectedCustomer.status,
    })
    console.log("deliveryPointDetails", deliveryPointDetails);
    setLargeModal(!largeModal);
    setIsview(true);
    setIsedit(false);
    setErrors({});
    setFormIsValid(true);
  }


  const deletetoggleDpoint = (items) => {

    setDeletepopup(true);
    setDeliveryPointDetails([{
      delPointCode: items.delPointCode,
      status: (items.status === "A") ? (items.status = "X") : (items.status = "A"),
    }]);
    console.log("setDeliveryPointDetails", deliveryPointDetails);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
  };


  const onChangeCommonpopup = (key, value) => {

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;


    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const numbnerpattern = /^(0|[1-9][0-9]*)$/;
    const decimalnumber = /^\d*\.?\d*$/;
    const addressPattern = /^[-a-zA-Z0-9_@./#&%*,.+-//]+(\s+[-a-zA-Z0-9_@./#&,%*.+-//]+)*$/;
    const pincodePattern = /^[1-9][0-9]{5}$/


    if (key == "delPointName") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["delPointName"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["delPointName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["delPointName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "delPointCode") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["delPointCode"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);

      } else if (!numbnerpattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["delPointCode"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["delPointCode"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "geoLat") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["geoLat"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!decimalnumber.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["geoLat"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["geoLat"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "geoLong") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["geoLong"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!decimalnumber.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["geoLong"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["geoLong"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "address1") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["address1"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!addressPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["address1"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["address1"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "address2") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["address2"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!addressPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["address2"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["address2"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "city") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["city"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["city"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["city"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }



    if (key == "state") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["state"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["state"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["state"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "country") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["country"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["country"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["country"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }


    if (key == "pinCode") {

      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["pinCode"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (value.length !== 6) {
        addFieldValue = { [key]: null };
        errorsLocal["pinCode"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }

      else if (!numbnerpattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["pinCode"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["pinCode"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    // if (key == "status") {
    //   if (!value) {
    //     addFieldValue = { [key]: null };
    //     errorsLocal["status"] = "select";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else if (!stringPattern.test(value)) {
    //     addFieldValue = { [key]: null };
    //     errorsLocal["status"] = "Invalid";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else {
    //     errorsLocal["status"] = "";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   }
    // }
    const newFormData = { ...deliveryPointDetails };
    newFormData[key] = value;
    // console.log("newFormDataonchange", newFormData);
    setDeliveryPointDetails(newFormData);

    console.log("deliveryPointDetails", deliveryPointDetails);
    console.log("formIsValid", formIsValid);
    console.log("errors", errors);


  }

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span
              style={{ color: "white", display: "flex" }}
              className="icon-top-left"
            >
               <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  onEditDpoint(tableMeta);
                }}
              >
                <i
                  className="ti-pencil tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link>
              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  viewDpoint(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="fa fa-eye tpen-bck"
                  style={{ marginLeft: "3px" }}
                ></i>
              </Link> 

              {/* <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  deletetoggleDpoint(tableMeta);
                }}
              >
                <i
                  className="ti-trash tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link> */}

             
            </span>

           
          </div>
        );
      },
    },
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const columns = [
    {
      name: "delPointCode",
      label: "Delivery Code",
      options: {
        filter: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "delPointName",
      label: "Delivery Point",
      options: {
        filter: false,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "city",
      label: "City",
      options: {
        filter: true, // Enable filter for Restaurant
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "state",
      label: "State ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "country",
      label: "Country ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "geoLat",
      label: "Latitude ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "geoLong",
      label: "Langtitude ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "status",
      label: "Status ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    actionOption,
  ];
  const options = {
    filter: true, // Enable global search
    search: true, // Disable individual column search (to avoid redundancy)
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "51vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterOptions,
      changedColumnIndex
    ) => {
      // Handle filter change here
      // You can update state or perform any other action based on the new filterList
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} // Call applyNewFilters to apply filters
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
    },
    onFilterDialogOpen: () => {
    },
    onFilterDialogClose: () => {
    },
    customToolbar: () => {
      return (
        <>
         
        </>
      );
    },
  };
  


  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });


  return (
    <>
      {!largeModal ? (
        <>
          <div className="row dly-slt">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 temp-crd">

              <Card>
                <div class="row ovrl-crd-hd">
                     <div class="col-3 col-md-3 col-lg-3">
                     <div class="form-group">
                    <h3 className="me-auto  main-hd">
                      Delivery Point
                    </h3>
                    </div>
                  </div>
                  <div class="col-9 col-md-9 col-lg-9 row">
                <Card.Header className="card-title  main-card mn-crd">
                <div class="col-12 col-md-12 col-lg-12 form-group" style={{display:"flex",justifyContent:"end"}}>
                          <Button
                          className="me-2"
                          variant="success dark btn-sm "
                          // disabled={restarantvalue.value == ""}
                          style={{ backgroundColor: "#1976d2",borderRadius:"7px" }}
                          onClick={(e) => {
                            opnAddDpointModal(e);

                          }}
                        >
                          <i
                            // class="fas fa-plus"
                            onClick={() => {

                            }}
                          >
                            Add Delivery Point{" "}
                          </i>{" "}
                        </Button>

                      
                    
                  </div>
                </Card.Header>
                </div>
                </div>
                <Card.Body className="scroll-tbl-fix-header tab-hd-clr"style={{ padding: "3px" }}>
                <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={deliverypointlist}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
                  {/* <Table responsive stripped >
                    <thead>
                      <tr>
                        <th>
                          Delivery Code
                        </th>
                        <th>
                          Delivery Point
                        </th>
                        <th>
                          City
                        </th>

                        <th>
                          State
                        </th>

                        <th>
                          Country
                        </th>

                        <th>
                          Latitude
                        </th>
                        <th>
                          Longitude
                        </th>

                        <th>
                          Status
                        </th>

                        <th>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {deliverypointlist && deliverypointlist.map((items) => {

                        return (<tr>
                          <td>
                            {items.delPointCode}

                          </td>
                          <td>
                            {items.delPointName}
                          </td>
                          <td>
                            {items.city}
                          </td>
                          <td>
                            {items.state}
                          </td>
                          <td>
                            {items.country}
                          </td>
                          <td>
                            {items.geoLat}
                          </td>
                          <td>
                            {items.geoLong}
                          </td>

                          <td>
                            {(
                              <div class="col-sm-6 col-md-5 col-xl-5 ">
                                <Switch
                                  checked={
                                    items?.status == "A"
                                  }
                                  style={{
                                    color:
                                      items?.status == "A"
                                        ? "green"
                                        : "red",
                                  }}
                                  onChange={() => {

                                    deletetoggleDpoint(items);

                                  }}
                                  aria-label="checkedA"
                                />{" "}
                                <span
                                  style={{
                                    color:
                                      items?.status == "A"
                                        ? "green"
                                        : "red",
                                    fontSize: "x-small",
                                    marginLeft: "-8px"
                                  }}
                                >
                                  {
                                    (items?.status == "A"
                                      ? "Active"
                                      : "Inactive")}
                                </span>
                              </div>
                            )}
                          </td>





                          {/* <div style={{ display: "flex" }}>
                              <span
                                className={`badge badge-xs ${items.status
                                  == "A"
                                  ? "badge-success"
                                  : "badge-danger"
                                  } mr-10 position-relative`}
                              >
                                &nbsp;
                              </span>
                              <span className="d-block">
                                {items.status == "A" ? "Verified" : "Not Verified"}
                              </span>
                            </div> */}

{/* 
                          <td style={{display:"flex"}}>
                            <i
                              onClick={() => {
                                //console.log("items", items);
                                onEditDpoint(items);
                              }}
                              style={{ fontSize: "16px" }}
                              className="ti-pencil tpen-bck"
                            ></i> */}
                            {/* <i
                              onClick={() => {
                                
                                deletetoggleDpoint(items);
                              }}
                              style={{
                                fontSize: "large",
                                paddingLeft: "15px",
                              }}
                              className="ti-trash"
                            >
                            </i> */}

                            {/* <i
                              onClick={() => {

                                viewDpoint(items);
                                console.log("items", items);
                              }}
                              style={{
                                fontSize: "15px",
                                marginLeft:"3px"
                              }}

                              className="fa fa-eye tpen-bck"></i>
                          </td>

                        </tr>
                        )
                      }
                      )}

                      {deliverypointlist?.length <= 0 ? (
                        <div style={{ color: "red", textAlign: 'center' }}> No Data Found </div>
                      ) : setDeliverypointlist}

                    </tbody>

                  </Table> */} 
                </Card.Body >
              </Card>

            </div>
          </div>
        </>
      ) : (
        <>
          <RctCollapsibleCard fullBlock>
            <RctCollapsibleCard fullBlock>
              <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
                {/* <h3 className="mb-3 me-auto" style={{ fontFamily: "Roboto" }}>
                  Create New
                </h3> */}
                <h3 className="mb-3 me-auto" style={{ fontFamily: "Roboto" }}>
                  {isView ? "View Delivery Point details" : isedit ? "Update Delivery Point details" : "Create New Delivery Point"}
                </h3>
                {largeModal && (
                  <button
                    className="btn btn-primary btn-rounded me-3 mb-2"
                    style={{ backgroundColor: "#008000" }}
                    onClick={() => {
                      setLargeModal(!largeModal);
                      setIsedit(false);
                      setIsview(false);
                      setErrors({});
                    }}
                  >
                    {" "}
                    Back{" "}
                  </button>
                )}
              </div>

              <div className="row">
                <Col xl="6">
                  <Card>
                    <Card.Header className="text-white bg-secondary">
                      <Card.Title style={{ color: "white" }}>
                        Delivery Point Details
                      </Card.Title>
                      {/* <i
              className="fas fa-redo"
              onClick={() => {
                console.log("finallog123", outletDetails);
                saveupdateoutlet();
              }} 
            ></i> */}
                    </Card.Header>
                    <Card.Body className="mb-0 bg-green-light">
                      <Card.Text style={{ fontSize: "medium" }}>
                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Delivery Point Name
                            <span class="text-warning">*</span>
                          </label>
                          <br />


                          <Input
                            type="text"
                            name="delPointName"
                            id="delPointName"
                            //placeholder="DelPointName"
                            maxLength="50"
                            value={deliveryPointDetails?.delPointName}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {

                              onChangeCommonpopup(
                                "delPointName", e.target.value
                              );
                              // console.log("delPointName", e.target.value);

                            }
                            }
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["delPointName"]}
                          </span>
                        </div>


                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Delivery Point Code
                            <span class="text-warning">*</span>
                          </label>
                          <br />


                          <Input
                            type="number"
                            name="delPointCode"
                            id="delPointCode"
                            // placeholder="DelPointCode"
                            maxLength="10"
                            value={deliveryPointDetails?.delPointCode}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}

                            onChange={(e) => {

                              onChangeCommonpopup(
                                "delPointCode", e.target.value
                              );
                              //console.log("delPointName", e.target.value);

                            }
                            }
                            disabled={isView || isedit}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["delPointCode"]}
                          </span>
                        </div>

                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="Country"> Latitude</label>
                            <Input
                              type="number"
                              name="GeoLat"
                              id="geoLat"
                              // placeholder="geoLat"
                              maxLength="30"
                              disabled={isView}
                              value={deliveryPointDetails?.geoLat}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) =>
                                onChangeCommonpopup(
                                  "geoLat",
                                  e.target.value
                                )
                              }
                            />

                            <span style={{ color: "red" }}>
                              {errors["geoLat"]}
                            </span>
                          </div>

                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="pincode"> Longitude</label>
                            <Input
                              type="number"
                              name="geoLong"
                              id="geoLong"
                              // placeholder="GeoLong"
                              maxLength="30"
                              disabled={isView}
                              value={deliveryPointDetails?.geoLong}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {
                                onChangeCommonpopup(
                                  "geoLong",
                                  e.target.value
                                )
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {errors["geoLong"]}
                            </span>
                          </div>
                        </div>



                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>



                <Col xl="6">
                  <Card>
                    <Card.Header className="text-white bg-secondary">
                      <Card.Title style={{ color: "white" }}>
                        Address
                      </Card.Title>
                    </Card.Header>
                    <Card.Body className="mb-0 bg-green-light">
                      <Card.Text style={{ fontSize: "medium" }}>



                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Address 1
                            {/* <span class="text-warning"></span> */}
                          </label>
                          <br />


                          <Input
                            type="textarea"
                            name="Address1"
                            id="Address1"
                            //placeholder="Address 1"
                            maxLength="150"

                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup(
                                "address1",
                                e.target.value
                              )
                            }}
                            disabled={isView}
                            value={deliveryPointDetails?.address1}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["address1"]}
                          </span>
                        </div>


                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Address 2
                            {/* <span class="text-warning"></span> */}
                          </label>
                          <br />
                          <Input
                            type="textarea"
                            name="Address2"
                            id="Address2"
                            //placeholder="Address 2"
                            maxLength="150"

                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup(
                                "address2",
                                e.target.value
                              )
                            }}
                            disabled={isView}
                            value={deliveryPointDetails?.address2}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["address2"]}
                          </span>
                        </div>

                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="City"> City</label>
                            <Input
                              type="text"
                              name="city"
                              id="city"
                              //placeholder="city"
                              maxLength="50"
                              disabled={isView}
                              value={deliveryPointDetails.city}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {
                                onChangeCommonpopup(
                                  "city",
                                  e.target.value
                                )
                              }}
                            />

                            <span style={{ color: "red" }}>
                              {errors["city"]}
                            </span>
                          </div>


                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="state"> State</label>
                            <Input
                              type="text"
                              name="state"
                              id="state"
                              // placeholder="state"
                              maxLength="50"
                              disabled={isView}
                              value={deliveryPointDetails.state}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {

                                onChangeCommonpopup(
                                  "state",
                                  e.target.value
                                )
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {errors["state"]}
                            </span>
                          </div></div>


                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="Country"> Country</label>
                            <Input
                              type="text"
                              name="country"
                              id="country"
                              // placeholder="country"
                              maxLength="50"
                              disabled={isView}
                              value={deliveryPointDetails?.country}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {
                                onChangeCommonpopup(
                                  "country",
                                  e.target.value
                                )
                              }}
                            />

                            <span style={{ color: "red" }}>
                              {errors["country"]}
                            </span>
                          </div>

                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="pinCode"> Pincode</label>
                            <Input
                              type="text"
                              name="pinCode"
                              id="pinCode"
                              // placeholder="pinCode"
                              maxLength="6"
                              disabled={isView}
                              value={deliveryPointDetails?.pinCode}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {
                                onChangeCommonpopup(
                                  "pinCode",
                                  e.target.value
                                )

                              }}
                            />
                            <span style={{ color: "red" }}>
                              {errors["pinCode"]}
                            </span>
                          </div>



                        </div>

                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

               
                <div class="text-right ">
                { !isView &&  
                  <Button
                    variant="contained mr-2"
                    className="btn-danger mr-2 "
                    style={{marginRight:"40px"}}
                    onClick={() => {
                      

                      setDeliveryPointDetails({
                        delPointName: "",
                        address1: "",
                        address2: "",
                        country: "",
                        delPointCode: "",
                        city: "",
                        state: "",
                        pinCode: "",
                        geoLat: "",
                        geoLong: "",
                        status: "",
                      });
                    }}
                  >
                    Clear
                  </Button>}





                  {!isView && !isedit && (
                    <Button
                      variant="contained"
                      // className="btn-info text-white me-3"

                      style={{ backgroundColor: "#008000",marginRight:"40px" }}
                      disabled={!formIsValid}
                      className={
                        !formIsValid
                          ? "btn-disabled mr-1"
                          : "btn-info text-white me-3 mr-"
                      }

                      onClick={() => {
                        saveupdateDeliveryPoint();
                        // saveupdatecustomer();
                      }}
                    >
                      Save
                    </Button>
                  )}
                  {isedit && (
                    <Button
                      variant="contained"
                      // className="btn-success text-white me-3"

                      // style={{ backgroundColor: "#008000" }}
                      className={!formIsValid ? 'btn-disabled' : 'btn-info text-white me-3'}
                      disabled={!formIsValid}
                      onClick={() => {

                        saveupdateDeliveryPoint();
                        // saveupdatecustomer();
                      }}
                    >
                      Update
                    </Button>
                  )}


                </div>


              </div>
            </RctCollapsibleCard>
          </RctCollapsibleCard>
        </>
      )}


      <Modal
        isOpen={
          deletepopup
        }
        // toggle={() => onClose()}
        // style={{

        //   maxWidth: (deletepopup && "700px")

        // }}
        backdrop="static"
      >
        <ModalHeader>
          {(deletepopup && " Status Update")}
        </ModalHeader>


        <ModalBody>
          {deletepopup && (
            <>
              {(deliveryPointDetails[0]?.status == "A") ? <span>Are you sure want to Active</span> :
                <span>
                  Are you sure want to InActive ?{" "}
                  <strong></strong>
                </span>}
            </>
          )}
        </ModalBody>


        <ModalFooter>
          {deletepopup && (
            <>
              <Button
                variant="success"
                onClick={() => {
                  deleteDeliveryPointlist();

                }}
              >
                Update
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDeletepopup(false);
                  getDeliverypointHistory();
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>

    </>

  )
}

export default DeliveryPointMaster;